import React from 'react';
import cx from 'classnames';
import { oneOf, bool } from 'prop-types';

import Grid, { GridCol } from './../Grid';

const CLASS_ROOT = 'loader';

const propTypes = {
  /** Centered in vertical and horizontal axis */
  isCentered: bool,
  /** Loader size */
  size: oneOf(['small', 'medium', 'large', 'xlarge', 'xxlarge']),
};

const defaultProps = {
  size: 'xxlarge',
};

const Loader = ({ className, children, isCentered, size, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
      [`${CLASS_ROOT}--centered`]: isCentered,
    },
    className
  );
  const boxes = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div className="loader-wrapper">
      <Grid className={classes} {...other}>
        {boxes.map((box, id) => (
          <GridCol
            size={4}
            key={id.toString()}
            className={`${CLASS_ROOT}-box ${CLASS_ROOT}-box-${id}`}
          />
        ))}
      </Grid>
    </div>
  );
};
Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js